module.exports = __webpack_public_path__ + "static/media/slide5.69b605d4.jpg";